export const YUP_REQUIRED = 'Required';
export const YUP_MUST_BE_VALID_EMAIL = 'Must be valid email';
export const YUP_MUST_BE_MORE_DETAILS = 'Please provide more details in the Relation field';
